import IdentityManagement from './IdentityManagement'
import PageViewEvent from './PageViewEvent'

export default () => {
  IdentityManagement()
  PageViewEvent()
}
